import React from 'react';
import { AnchorProps } from '@sls-react/components/Links/A';
import NewTabLink from './NewTabLink';
import qsStringify from '@sls-react/utils/qsStringify';

export const appStoreLink =
  'https://itunes.apple.com/app/apple-store/id1215421737?pt=118112125';

type Props = AnchorProps & {
  source: 'homepage' | 'footer';
};

const IosAppStoreLink: React.FC<Props> = ({ children, source, ...props }) => {
  const query = qsStringify({
    ct: source,
    pt: 118112125,
    mt: 8,
  });

  return (
    <NewTabLink
      href={`https://itunes.apple.com/app/apple-store/id1215421737${query}`}
      {...props}
      aria-label="Download our iOS App"
    >
      {children}
    </NewTabLink>
  );
};

export default IosAppStoreLink;
